import { HStack, VStack, Pressable } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { Icon } from "@repo/core/components/core/Icon";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { InstallmentOptionProps } from "./types";

export const InstallmentOption = ({
  installments,
  installmentValue,
  totalValue,
  onPress,
  isBestOption = false,
  isSelected = false
}: InstallmentOptionProps) => {
  const formattedInstallmentValue = numberToBrl(installmentValue);
  const currency = formattedInstallmentValue.substring(0, 3);
  const value = formattedInstallmentValue.substring(3);

  return (
    <Pressable onPress={onPress}>
      <VStack
        justifyContent="center"
        h={isBestOption ? 96 : 64}
        px="$4"
        py="$3"
        gap={8}
        borderWidth={2}
        borderColor={isSelected ? "$primary700" : "$borderLight200"}
        borderRadius="$md"
        bg={isSelected ? "$primary0" : "$backgroundDark0"}
      >
        {isBestOption && (
          <Text fontSize="$xs" fontWeight={500} color="$primary700">
            Melhor Parcelamento
          </Text>
        )}
        <HStack justifyContent="space-between" alignItems="center">
          <HStack alignItems="baseline" gap={8}>
            <Text
              fontSize={isBestOption ? "$xl" : "$md"}
              fontWeight={500}
              fontFamily="$body"
              lineHeight={isBestOption ? 28 : 22}
              color="$textLight900"
            >
              {installments}x
            </Text>
            {isBestOption ? (
              <HStack alignItems="baseline">
                <Text
                  fontSize="$xl"
                  fontWeight={500}
                  lineHeight={20}
                  color="$textLight700"
                >
                  {currency}
                </Text>
                <Text
                  fontSize="$3xl"
                  fontWeight={500}
                  lineHeight={40}
                  color="$primary700"
                >
                  {value}
                </Text>
              </HStack>
            ) : (
              <Text
                fontSize="$sm"
                fontWeight={500}
                lineHeight={20}
                color="$textLight700"
              >
                {formattedInstallmentValue}
              </Text>
            )}
          </HStack>
          <HStack alignItems="center" gap={8}>
            <Text fontSize="$xs" color="$textLight700">
              {numberToBrl(totalValue)}
            </Text>
            <Icon name="chevron-right" size={20} color="$textLight700" />
          </HStack>
        </HStack>
      </VStack>
    </Pressable>
  );
};
